import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import Button from 'components/helpers/Button';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { getTextAlignFromEnum } from 'lib/sitecore/component-params';
import { classnames } from 'tailwindcss-classnames';
import EditingHelpText from 'components/helpers/EditingHelpText';
import { ButtonVariant } from 'components/helpers/Button/WithButton';
import { isBanner } from 'lib/sitecore';

export type BannerProps = {
  fields: {
    banner: Sitecore.Override.ItemEx & Components.General.Banner.Fields.Banner;
  };
};

const getDisplayName = (source: Sitecore.Override.ItemEx): string =>
  source?.displayName ?? 'Banner';

const Banner = (props: BannerProps): JSX.Element => {
  const { fields } = props;
  if (!fields?.banner) {
    return <></>;
  }
  if (!isBanner(fields.banner)) {
    return (
      <EditingHelpText
        text={`Banner "${getDisplayName(fields.banner)}" is not a valid banner`}
        block
      />
    );
  }
  const textAlignClass = getTextAlignFromEnum(fields.banner.fields.textAlignment);

  const headingProps = propsFromFields(fields.banner.fields);

  const cta2TypeField = fields.banner.fields.cta2Type.value;
  const cta2Type: ButtonVariant =
    cta2TypeField === 'Default' || cta2TypeField.trim().length === 0
      ? 'link'
      : (cta2TypeField.toLowerCase() as ButtonVariant);

  return (
    <>
      <div
        data-component="authorable/general/banner"
        className={classnames(
          textAlignClass,
          'theme-night-tint',
          'bg-theme-bg',
          'text-theme-text',
          'p-4'
        )}
      >
        <div>
          <Heading {...headingProps} />
          <Button linkField={fields.banner.fields.cta1} variant="link" />
          <Button linkField={fields.banner.fields.cta2} variant={cta2Type} />
        </div>
      </div>
    </>
  );
};

export default Banner;
